module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_004_lg-1bc170b9.png";